import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  private _windowHeight = new BehaviorSubject<any>(0);
  windowHeight = this._windowHeight.asObservable();
  
  private _vehicles = new BehaviorSubject<any>([]);
  vehicles = this._vehicles.asObservable();
  staticVehicle:any = [];
  
  private _userPois = new BehaviorSubject<any>([]);
  userPois = this._userPois.asObservable();
  staticUserPois:any = [];
  
  private _userZones = new BehaviorSubject<any>([]);
  userZones = this._userZones.asObservable();
  staticUserZones:any = [];
  
  private _isLoggedIn = new BehaviorSubject<any>(false);
  isLoggedIn = this._isLoggedIn.asObservable();
  
  private _rightStatusTrigger = new BehaviorSubject('All');
  rightStatusTrigger = this._rightStatusTrigger.asObservable();

  private _mapLoaded = new BehaviorSubject<any>(true);
  mapLoaded = this._mapLoaded.asObservable();

  private decodedCoords:any = {};

  private mapProvider = localStorage.getItem('OncoreMapProvider')? localStorage.getItem('OncoreMapProvider') : "OpenStreetMap";
  
  globalVehicleStatusGroups = [
	'All',
	'Active',
	'Idle',
	'Stop',
  ];
  private _vehicleStatusGroups = new BehaviorSubject(this.globalVehicleStatusGroups);
  vehicleStatusGroups = this._vehicleStatusGroups.asObservable();
  
  private _vehicleGroups = new BehaviorSubject([]);
  vehicleGroups = this._vehicleGroups.asObservable();
  
  private _vehicleFiltered = new BehaviorSubject([]);
  vehicleFiltered = this._vehicleFiltered.asObservable();
  
  private _dropDownFilterValue = new BehaviorSubject('All');
  dropDownFilterValue = this._dropDownFilterValue.asObservable();
  
  private _openedInfoWindows = new BehaviorSubject([]);
  openedInfoWindows = this._openedInfoWindows.asObservable();
  
  private _newInfoWindowToOpen = new BehaviorSubject({});
  newInfoWindowToOpen = this._newInfoWindowToOpen.asObservable();
  
  private _oldInfoWindowToClose = new BehaviorSubject({});
  oldInfoWindowToClose = this._oldInfoWindowToClose.asObservable();
  
  private _showMultipleOnMap = new BehaviorSubject(true);
  showMultipleOnMap = this._showMultipleOnMap.asObservable();
  showMulVehicles = true;
  
  private _tripMarkers = new BehaviorSubject([]);
  tripMarkers = this._tripMarkers.asObservable();
  
  private _mapInstance = new BehaviorSubject<any>({});
  mapInstance = this._mapInstance.asObservable();
  mapStatic:any = {};
  
  private _showControl = new BehaviorSubject(true);
  showControl = this._showControl.asObservable();
  
  private _logoutTriggered = new BehaviorSubject(false);
  logoutTriggered = this._logoutTriggered.asObservable();

  private _collectionJsonData = new BehaviorSubject<any>({});
  collectionJsonData = this._collectionJsonData.asObservable();
  
  initState = true;
  tmpInfoWdws = [];

  prevCoords:any = {};

  trackSolidAccounts:any = [];
  tempTrackSolidUsers:any = [];
  
  constructor(private apiSvc: ApiService) { }
  
  /**
   * control screen responsiveness
   */
  setwindowHeight(height){
	this._windowHeight.next(height);
  }
  
  /**
   * update here to be used in different classes
   */
  setVehicles(vehicles){
	this._vehicles.next(vehicles);
	this.staticVehicle = vehicles;
	if(this.initState){
		this._vehicleFiltered.next(vehicles);
		if(vehicles?.length > 0){
			this.initState = false;
		}
	}
  }
  
  setUserPois(pois){
	this._userPois.next(pois);
	this.staticUserPois = pois;
  }
  
  setUserZones(zones){
	this._userZones.next(zones);
	this.staticUserZones = zones;
  }
  
  setRightStatusTrigger(stt){
	this._rightStatusTrigger.next(stt);
  }
  
  /**
   * especially to show/hide sidebar
   */
  setIsLoggedIn(status){
	this._isLoggedIn.next(status);
  }
  
  /**
   * update here to be used in different classes
   */
  setVehicleGroups(groups){
	this._vehicleGroups.next(groups);
  }

  setMapLoaded(flag){
	this._mapLoaded.next(flag);
  }
  
  /**
   * get session stored in local browser
   */
  getLocalSession(){
	let localSess = sessionStorage.getItem('user');
	return JSON.parse(localSess);
  }
  
  /**
   * logout function
   * remove session stored in local browser
   */
   logout(){
	// remove session locally
	sessionStorage.removeItem('user');
	sessionStorage.removeItem('master-user');
	// remove flag isLoggedIn
	this.setIsLoggedIn(false);
	// remove all vehicles list
	this.setVehicles([]);
	// re-init state of vehicle
	this.initState = true;
	// clear marker vehicles
	if(localStorage.getItem('markerShown')){
		localStorage.removeItem('markerShown');
	}
  if(localStorage.getItem('jump_direct')){
		localStorage.removeItem('jump_direct');
	}
	// clear trip time range
	if(localStorage.getItem('trip-start')){
		localStorage.removeItem('trip-start');
	}
	if(localStorage.getItem('trip-end')){
		localStorage.removeItem('trip-end');
	}
  if(localStorage.getItem('user-vehicle-ids')){
    localStorage.removeItem('user-vehicle-ids');
  }
  if(localStorage.getItem('OncoreMapProvider')){
    localStorage.removeItem('OncoreMapProvider');
    this.setMapType("OpenStreetMap");
  }
  this.removeUsersVehicleObjIds();
	this.setLogoutTriggered(true);
	// redirect to login page
	this.apiSvc.navigateInternal('');
   }
   
  /**
   * vehicle to be shown after filter
   */
  setVehicleFiltered(vehicles){
	this._vehicleFiltered.next(vehicles);
  }
  
  /**
   * store value of vehicle filter
   */
  setDropDownFilterValue(value){
	this._dropDownFilterValue.next(value);
  }
  
  /**
   * store value of vehicle filter
   */
  setOpenedInfoWindows(value){
	this.tmpInfoWdws.push(value);
	this._openedInfoWindows.next(this.tmpInfoWdws);
  }
  
  /**
   * store value of vehicle filter
   */
  setNewInfoWindowToOpen(value){
	this._newInfoWindowToOpen.next(value);
  }
  
  /**
   * store value of vehicle filter
   */
  setOldInfoWindowToClose(value){
	this._oldInfoWindowToClose.next(value);
  }
  
  /**
   * a flag to indicate can show more than 1 vehicle on map or not
   */
  setShowMultipleOnMap(status){
	this._showMultipleOnMap.next(status);
	this.showMulVehicles = status
  }
  
  /**
   * store value of vehicle filter
   */
  setTripMarkers(value){
	this._tripMarkers.next(value);
  }
  
  setMapInstance(value){
	this._mapInstance.next(value);
	this.mapStatic = value;
  }
  
  setShowControl(value){
	this._showControl.next(value);
  }
  
  setLogoutTriggered(value){
	this._logoutTriggered.next(value);
  }

  getMapFields(){
    let localObj:any = localStorage.getItem('map-fields');
    return JSON.parse(localObj);
  }

  setMapFields(data:any){
    let dataCompr = JSON.stringify(data);
    let localObj:any = localStorage.setItem('map-fields', dataCompr);
  }

  getMapFieldIds(){
    return [{
      col: 'coordinate',
      name: 'Coordinate',
      value: 1,
      icon: 'map-marker',
      width:'100'
    },{
      col: 'geolocation',
      name: 'Location',
      value: 1,
      icon: 'globe',
      width:'100'
    },{
      col: 'drivernamedefault',
      name:'Driver',
      value: 1,
      icon: 'user',
      width:'48'
    },{
      col: 'engine',
      name: 'Engine',
      value: 1,
      icon: 'power-off',
      width:'48'
    },{
      col: 'speed',
      name: 'Speed',
      value: 1,
      icon: 'tachometer',
      width:'48'
    },{
      col: 'direction',
      name: 'Direction',
      value: 1,
      icon: 'location-arrow',
      width:'48'
    },{
      col: 'description',
      name:'Desc',
      value:1,
      icon: 'car',
      width:'48'
    },{
      col: 'fuelValue',
      name:'Fuel',
      value: 1,
      icon: 'filter',
      width:'48'
    },{
      col: 'otherAttribute',
      name: 'Others',
      value: 1,
      icon: 'spinner',
      width:'48'
    }];
  }

  getDecodedCoords(coord){
    if(!this.decodedCoords[coord]){
      return false;
    }

    return this.decodedCoords[coord];
  }

  setDecodedCoords(coord, addr){
    if(!this.decodedCoords[coord]){
      this.decodedCoords[coord] = addr;
    }
  }

  getPrevCoords(){
    return this.prevCoords;
  }

  setPrevCoords(data){
    this.prevCoords = data;
  }

  setUsersVehicleIds(data:any){
    let dataCompr = JSON.stringify(data);
    let localObj:any = localStorage.setItem('user-vehicle-ids', dataCompr);
  }
  
  getUsersVehicleIds(){
    let localStr:any = localStorage.getItem('user-vehicle-ids');
    let localObj:any = [];
    if(localStr){
      localObj = JSON.parse(localStr);
    }
    return localObj;
  }

  removeUsersVehicleIds(){
    localStorage.removeItem('user-vehicle-ids');
  }

  setCollectionJsonData(data){
    this._collectionJsonData.next(data);
  }

  getMapType(){
    return this.mapProvider;
  }

  setMapType(mapType){
    this.mapProvider = mapType;
    localStorage.setItem('OncoreMapProvider', mapType)
  }

  tokenExpiryChecker(){
    let ieExpired = false;
    let trackSolidToken = localStorage.getItem('tracksolidtoken');
    
    if(trackSolidToken){
      let tokenObj = JSON.parse(trackSolidToken);
      let tokenExp = tokenObj?.token_expiry;

      let currentDate = new Date();
      let tokenDate = new Date(tokenExp);
		  tokenDate.setTime(tokenDate.getTime() - 28800000);

      if(currentDate.getTime() < tokenDate.getTime()){
        ieExpired = true;
      }
    }

    return ieExpired;
  }

  getTraksolidtoken(){
    let token = "";
    let trackSolidToken = localStorage.getItem('tracksolidtoken');

    if(trackSolidToken){
      let tokenObj = JSON.parse(trackSolidToken);
      token = tokenObj?.token;
    }

    return token;
  }

  getAllTokenData(){
    let trackSolidToken = localStorage.getItem('tracksolidtoken') || "{}";
    let tokenObj = JSON.parse(trackSolidToken);
    
    return tokenObj;
  }

  setUsersVehicleObjIds(data:any){
    let dataCompr = JSON.stringify(data);
    let localObj:any = localStorage.setItem('user-vehicle-obj-ids', dataCompr);
  }
  
  getUsersVehicleObjIds(){
    let localStr:any = localStorage.getItem('user-vehicle-obj-ids');
    let localObj:any = [];
    if(localStr){
      localObj = JSON.parse(localStr);
    }
    return localObj;
  }

  removeUsersVehicleObjIds(){
    if(localStorage.getItem('user-vehicle-ids')){
      localStorage.removeItem('user-vehicle-obj-ids');
    }
  }

  getTrackSolidAccounts(){
    let ret:any = [];
    if(localStorage.getItem('track_solid_accounts')){
      let valLocal = localStorage.getItem('track_solid_accounts') || "[]";
      ret = JSON.parse(valLocal);
    }

    return ret;
  }

  setTrackSolidAccounts(data){
    this.trackSolidAccounts = data;
    localStorage.setItem('track_solid_accounts', JSON.stringify(data));
  }

  setTempTrackSolidUsers(data){
    this.tempTrackSolidUsers = data;
  }

  getTempTrackSolidUsers(){
    return this.tempTrackSolidUsers;
  }
}
